<template>
  <div id="patient-details-resume-card">
    <div class="row">
      <va-card style="min-height: 320px; min-width: 520px">
        <div class="col-12">

          <div class="text-center mt-5" v-if="isLoading">
            <LoadingAnimation/>
          </div>
          <div v-else>
            <div class="d-flex justify--space-between">
              <h5 class="is-bold">{{title}}</h5>
              <div class="">
                <font-awesome-icon
                  v-if="!hideAddBtn"
                  icon="fa-solid fa-circle-plus"
                  class="clickable card-icon mr-3"
                  @click.prevent="$emit('handleCreateMeasurement')"
                />
                <font-awesome-icon
                  v-if="hasReferenceValuesTable"
                  icon="fa-solid fa-circle-info"
                  class="clickable card-icon mr-3"
                  @click.prevent="$emit('handleShowReferenceValuesModal')"
                />
                <font-awesome-icon
                  v-if="!isSelected && !hideTopIcon && !isLoading && data.length && data.length > 0"
                  icon="fa-solid fa-up-right-and-down-left-from-center"
                  class="clickable card-icon"
                  @click.prevent="$emit('cardClicked')"
                />
                <font-awesome-icon
                  v-if="isSelected && !hideTopIcon && !isLoading && canCreateMeasurement"
                  icon="fa-solid fa-down-left-and-up-right-to-center"
                  class="clickable card-icon"
                  @click.prevent="$emit('closeCardUpView')"
                />
                <!--<i v-if="!isSelected && !hideTopIcon && !isLoading" class="fa-solid fa-up-right-and-down-left-from-center clickable" @click.prevent="$emit('cardClicked')"></i>
                <i v-if="isSelected && !hideTopIcon && !isLoading" class="i-checkup-collapse-data clickable" @click.prevent="$emit('closeCardUpView')"></i>-->
              </div>
            </div>

            <div class="mt-3 card-container">
              <div class="left-div">
                <span :class="icon"/>
                <span class="is-bold mt-3 text-center"  v-if="data && data.length && data[0].isIndividualResult === true && data[0].lastChartResultObj.length">
                  <span :style="{color: data[0].lastChartResultObj[0].hexColourCode}">{{data[0].lastResults[0]}}</span>
                </span>
                <span class="is-bold mt-3 text-center" v-else-if="data && data.length && data[0].isIndividualResult === false && data[0].lastResults.length > 0">
                  {{data[0].lastResults[0]}}
                  <va-popover
                  placement="top">
                    <template #popover>
                      <ul style="margin: 0; padding-left: 1em;">
                        <li v-for="elem in data[0].lastResults">{{elem}}</li>
                      </ul>
                    </template>
                    <i class="fa fa-plus-circle"></i>
                  </va-popover>
                </span>
                <span class="is-bold mt-3 text-center" v-else>
                  N/A
                </span>
              </div>
              <div class="right-div" v-if="data.length && data.length > 0">
                <p class="is-bold text-center mb-1"> {{$t('checkup_plus.measurements.last_measurement')}} </p>
                <p class="text-center mb-1" v-if="Object.keys(statsData).length === 0">{{lastUpdate}}</p>
                <p class="text-center mb-1" v-for="(value, name) in statsData"> {{$t(`dashboard_new_evollu.measurement_types.${name}_short`)}}: {{ statsData[name].last }} </p>
              </div>
              <div class="right-div d-flex justify-content-center align-content-center flex-wrap" v-else>
                <p class="is-bold text-center mt-1" style="color: #b2723e">
                  {{$t('people_manager.no_results')}}
                </p>
              </div>
            </div>
          </div>

          <div class="text-center">
            <label style="font-size: 12.5px" :class="{'recent-update': hasBeenUpdatedRecently}">{{$t('dashboard_new_evollu.titles.last_update')}}: {{lastUpdate || "N/A"}} </label>
          </div>
        </div>

      </va-card>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";
import CreateMeasurementModal from "@/components/checkup_plus/patients/ParametersDetails/CreateMeasurementModal.vue";

export default {
  components: {CreateMeasurementModal, LoadingAnimation},
  props: {
    hideTopIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    hideAddBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    lastUpdate: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    statsData: {
      required: true,
      type: Object
    },
    isSelected: {
      required: false,
      type: Boolean,
      default: false
    },
    canCreateMeasurement: {
      required: true,
      type: Boolean,
      default: false
    },
    hasReferenceValuesTable: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCreateMeasurementModal: false
    }
  },
  methods: {
  },
  created() {
  },
  computed: {
    hasBeenUpdatedRecently: function () {
      if(this.lastUpdate !== null) {
        return moment().diff(moment(this.lastUpdate), 'hours' )  < 12
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.card-container {
  display: flex;
  min-height: 215px;
}

.card-container::after {
  content: "";
  display: table;
  clear: both;
}

.left-div {
  width: 30%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right-div {
  width: 70%;
  float: left;
}

.left-div, .right-div {
  padding: 10px;
  box-sizing: border-box;
}

.recent-update {
  color: #73d30a;
}

.card-icon {
  color: $vue-green;
  font-size: 22px;
}

</style>
